export const relationTypes = {
  isPartOf: 'IS_PART_OF',
  references: 'REFERENCES',
  replaces: 'REPLACES',
};
